export default function ConditionsPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="text-2xl font-bold mb-6">Conditions d’utilisation</h1>

      <p className="mb-4">
        InventoPro permet de créer des inventaires de biens immobiliers en ligne.
      </p>

      <p className="mb-4">
        L’utilisateur est responsable de son compte et de ses identifiants.
      </p>

      <p className="mb-4">
        Certaines fonctionnalités sont accessibles via abonnement payant.
      </p>

      <p className="mb-4">
        Les abonnements ne sont pas remboursables sauf en cas de problème technique empêchant l’utilisation du service.
      </p>

      <p className="mb-4">
        Nous ne garantissons pas un service sans interruption.
      </p>
    </div>
  );
}
